import { TbClock, TbShield, TbShieldOff, TbShieldHalf, TbPencil, TbTrash, TbUsers, TbUserPlus } from "react-icons/tb";

const POLICY_CONFIG = {
  free: {
    label: "Annulation gratuite",
    icon: TbShield,
    bg: "bg-green-50", text: "text-green-700", border: "border-green-200",
    accent: "bg-green-400",
  },
  partial: {
    label: "Partielle",
    icon: TbShieldHalf,
    bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200",
    accent: "bg-amber-400",
  },
  non_refundable: {
    label: "Non remboursable",
    icon: TbShieldOff,
    bg: "bg-red-50", text: "text-red-600", border: "border-red-200",
    accent: "bg-red-400",
  }
};

const MEAL_LABELS = {
  none: null,
  breakfast: { label: "Petit-déjeuner", emoji: "🍳" },
  half_board: { label: "Demi-pension", emoji: "🍽️" },
  full_board: { label: "Pension complète", emoji: "🍱" }
};

const Tag = ({ icon: Icon, label, bg, text, border }) => (
  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-medium whitespace-nowrap ${bg} ${text} ${border}`}>
    {Icon && <Icon size={11} className="shrink-0" />}
    {label}
  </span>
);

const RatePlanCard = ({ plan, handleEdit, handleDelete }) => {
  const policyType = plan.cancellationPolicy?.type || "free";
  const policy = POLICY_CONFIG[policyType];
  const PolicyIcon = policy.icon;
  const meal = MEAL_LABELS[plan.mealPlan];
  const guestPolicy = plan.extraGuestPolicy;
  const hasGuestFees = guestPolicy?.extraAdultFee > 0 || guestPolicy?.extraChildFee > 0;

  const hasTags = meal ||
    (policyType !== "non_refundable" && plan.cancellationPolicy?.hoursBeforeArrival > 0) ||
    guestPolicy?.baseOccupancy > 0 ||
    hasGuestFees;

  return (
    <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden hover:border-gray-200 hover:shadow-lg hover:shadow-gray-100/60 hover:-translate-y-0.5 transition-all duration-200 flex flex-col">

      {/* Barre d'accent colorée */}
      <div className={`h-[3px] w-full ${policy.accent}`} />

      <div className="p-4 flex flex-col gap-3">

        {/* HEADER */}
        <div className="flex flex-col gap-1.5">
          <span className={`self-start inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-semibold ${policy.bg} ${policy.text} ${policy.border}`}>
            <PolicyIcon size={10} className="shrink-0" />
            {policyType === "partial"
              ? `Partielle — ${plan.cancellationPolicy?.penaltyPercentage}%`
              : policy.label}
          </span>
          <h3 className="text-sm font-bold text-gray-900 leading-snug">{plan.name}</h3>
          {plan.description && (
            <p className="text-[11px] text-gray-400 line-clamp-2 leading-relaxed">{plan.description}</p>
          )}
        </div>

        {/* TAGS */}
        {hasTags && (
          <div className="flex flex-wrap gap-1.5">
            {policyType !== "non_refundable" && plan.cancellationPolicy?.hoursBeforeArrival > 0 && (
              <Tag icon={TbClock} label={`${plan.cancellationPolicy.hoursBeforeArrival}h avant`}
                bg="bg-gray-50" text="text-gray-500" border="border-gray-100" />
            )}
            {meal && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-medium whitespace-nowrap bg-blue-50 text-blue-700 border-blue-100">
                {meal.emoji} {meal.label}
              </span>
            )}
            {guestPolicy?.baseOccupancy > 0 && (
              <Tag icon={TbUsers} label={`${guestPolicy.baseOccupancy} pers.`}
                bg="bg-purple-50" text="text-purple-700" border="border-purple-100" />
            )}
            {hasGuestFees && (
              <Tag icon={TbUserPlus} label={`+${guestPolicy.extraAdultFee}€/adulte`}
                bg="bg-indigo-50" text="text-indigo-700" border="border-indigo-100" />
            )}
          </div>
        )}

        {/* ACTIONS */}
        <div className="flex gap-2 pt-3 border-t border-gray-50 mt-auto">
          <button onClick={() => handleEdit(plan)}
            className="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-[var(--k-green)] text-xs font-semibold hover:bg-green-50 transition-all duration-150">
            <TbPencil size={14} /> Modifier
          </button>
          <div className="w-px bg-gray-100" />
          <button onClick={() => handleDelete(plan)}
            className="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-red-400 text-xs font-semibold hover:bg-red-50 transition-all duration-150">
            <TbTrash size={14} /> Supprimer
          </button>
        </div>

      </div>
    </div>
  );
};

export default RatePlanCard;